import { DEMO_CLIENT_PHOTO_FILES } from './demoClientPhotoFiles';

/** The stock portraits the app carries for the invented caseload, as an instance so a test can hand in its own. */
export class DemoClientPhotoCatalog {
    static inject = () => [];

    files: string[] = DEMO_CLIENT_PHOTO_FILES;
}
